exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".graph{max-width:100%;width:93%;min-width:300px;margin:3% 6% 3% 5%}tr.tr-only-hide{color:#d20b2a}@media (max-width:736px){.table-rwd{min-width:100%}tr.tr-only-hide{display:none!important}.table-rwd tr{display:block;border:1px solid #ddd;margin-top:5px}.table-rwd td{text-align:left;font-size:15px;overflow:hidden;width:100%;display:block}.table-rwd td:before{content:attr(data-th) \" : \";display:inline-block;text-transform:uppercase;font-weight:700;margin-right:10px;color:#d20b2a}.table-rwd.table-bordered,.table-rwd.table-bordered td,.table-rwd.table-bordered th{border:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-8bb31d5c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/My_KH.vue
// module id = 530
// module chunks = 0